import { FC, useContext } from "react";
import MarketExpansionFilters from "@app/overviews/market-expansion-dashboard/components/MarketExpansionFilters";
import MarketExpansionFiltersContextProvider, { MarketExpansionFiltersContext } from "@app/overviews/market-expansion-dashboard/contexts/MarketExpansionFiltersContext";
import { MarketExpansionMapDataContextProvider } from "@app/overviews/market-expansion-dashboard/contexts/MarketExpansionMapDataContext";
import { MembershipMapDataContextProvider } from "@app/overviews/market-expansion-dashboard/contexts/MembershipMapDataContext";
import { ContractEntityColorTheme } from "@app/overviews/market-expansion-dashboard/contexts/ContractEntityColorThemeContext";
import { ProviderFootprintMapDataContextProvider } from "@app/overviews/market-expansion-dashboard/contexts/ProviderFootprintMapDataContext";
import { ProviderLandscapeMapDataContextProvider } from "@app/overviews/market-expansion-dashboard/contexts/ProviderLandscapeMapDataContext";
import MembershipTile from "@app/overviews/market-expansion-dashboard/tiles/MembershipTile";
import ProviderFootprintTile from "@app/overviews/market-expansion-dashboard/tiles/ProviderFootprintTile";
import ProviderLandscapeTile from "@app/overviews/market-expansion-dashboard/tiles/ProviderLandscapeTile";
import ContractEntityServiceAreaDetailsTable from "@app/overviews/market-expansion-dashboard/tiles/ContractEntityServiceAreaDetailsTable";
import MarketShareTile from "@app/overviews/market-expansion-dashboard/tiles/MarketShareTile";
import { Forbidden } from "@app/shared/ErrorPages";
import Breadcrumbs from "@app/shared/breadcrumbs/Breadcrumbs";
import Page from "@app/shared/Page";
import PageHeader from "@app/shared/PageHeader";
import PageInner from "@app/shared/PageInner";
import PageSection from "@app/shared/PageSection";
import { BreadcrumbTemplateEnum } from "@app/shared/breadcrumbs/breadcrumbTemplates";

export const WrappedMarketExpansionDashboard: FC = () => {
  const { marketExpansionForbiddenError } = useContext(MarketExpansionFiltersContext);

  if (marketExpansionForbiddenError) {
    return <Forbidden />;
  }

  return (
    <Page documentTitle="New Market Expansion">
      <Breadcrumbs template={BreadcrumbTemplateEnum.Overviews} items={["New Market Expansion"]} />
      <PageInner>
        <PageHeader title="New Market Expansion" disableHR={true}>
        </PageHeader>
        <PageSection>
          <MarketExpansionFilters />
          <div className="row">
            <div className="col-12 market-expansion-large-view-col-4 market-expansion-dashboard__line-separator">
              <MembershipTile />
              <MarketShareTile />
            </div>
            <div className="col-12 market-expansion-large-view-col-8">
              <div className="row">
                <div className="col-12 market-expansion-large-view-col-6">
                  <ProviderLandscapeTile />
                </div>
                <div className="col-12 market-expansion-large-view-col-6">
                  <ProviderFootprintTile />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <ContractEntityServiceAreaDetailsTable />
                </div>
              </div>
            </div>
          </div>
        </PageSection>
      </PageInner>
    </Page>
  );
};

const MarketExpansionDashboard: FC = () => (
  <MarketExpansionFiltersContextProvider>
    <MarketExpansionMapDataContextProvider>
      <MembershipMapDataContextProvider>
        <ProviderLandscapeMapDataContextProvider>
          <ProviderFootprintMapDataContextProvider>
            <ContractEntityColorTheme.Provider>
              <WrappedMarketExpansionDashboard />
            </ContractEntityColorTheme.Provider>
          </ProviderFootprintMapDataContextProvider>
        </ProviderLandscapeMapDataContextProvider>
      </MembershipMapDataContextProvider>
    </MarketExpansionMapDataContextProvider>
  </MarketExpansionFiltersContextProvider>
)

export default MarketExpansionDashboard;
